module.exports = __webpack_public_path__ + "ua.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ua.svg
// module id = 1116
// module chunks = 0